import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "label"
}
const _hoisted_2 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_input = _resolveComponent("q-input")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.label && !_ctx.editing || _ctx.disableEditing)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _renderSlot(_ctx.$slots, "label", { inputState: _ctx.inputState }, () => [
            _createElementVNode("label", null, _toDisplayString(_ctx.label), 1)
          ], true)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(["value", { 'static': !_ctx.editing || _ctx.disableEditing, editing: _ctx.editing && !_ctx.disableEditing }])
    }, [
      (!_ctx.editing || _ctx.disableEditing)
        ? _renderSlot(_ctx.$slots, "static", {
            key: 0,
            inputState: _ctx.inputState
          }, () => [
            (_ctx.inputState.value)
              ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.formatIBANLabel(_ctx.inputState.value)), 1))
              : _createCommentVNode("", true)
          ], true)
        : _renderSlot(_ctx.$slots, "input", {
            key: 1,
            inputState: _ctx.inputState
          }, () => [
            _createVNode(_component_q_input, {
              modelValue: _ctx.inputState.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.inputState.value) = $event)),
              label: "IBAN number",
              mask: "AA | ## | AAAA | #### | #### | ##",
              "bg-color": "white",
              "fill-mask": "",
              "unmasked-value": "",
              "hide-bottom-space": "",
              borderless: "",
              outlined: "",
              filled: "",
              dense: "",
              flat: ""
            }, null, 8, ["modelValue"])
          ], true)
    ], 2)
  ], 64))
}